<template>
  <generic-modal
    v-bind="$props"
    :value="value"
    confirm-color="error"
    confirm-text="Leave and lose changes"
    title="Leave with unsaved changes"
    persistent
    v-on="$listeners"
  >
    <p>Are you sure that you want to navigate away from this page?</p>
    <p>You have unsaved changes, and you will lose them if you leave this page</p>
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/modals/generic-modal'

export default {
  name: 'ExitModal',
  components: {
    GenericModal,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
